import Immutable, { fromJS } from 'immutable'
import { updateObject } from 'utils/updateObject'

const setFilters = (state, { payload }) => {
  let currentFilters = Immutable.Map(state.filters)
  const updateTasks = Array.isArray(payload) ? payload : [].concat([payload])

  updateTasks.forEach((task) => {
    const field = currentFilters.get(task.fieldName)
    let payload
    const newValue = task.value

    if (field instanceof Object && !(field instanceof Array)) {
      const applyObject = Object.prototype.hasOwnProperty.call(field, 'value')
        ? { value: newValue }
        : newValue
      payload = fromJS(currentFilters.get(task.fieldName)).merge(applyObject)
    } else {
      payload = newValue
    }
    
    currentFilters = currentFilters.set(task.fieldName, payload)
  })

  return updateObject(state, {
    filters: currentFilters.toJS(),
  })
}

export default setFilters
